import { useAlert, useNotification } from '@btime/react-messager'
import { useMutation, gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveProject($id: Int) {
    removeProject(id: $id)
  }
`

export const useRemoveProject = () => {
  const notify = useNotification()
  const { t } = useTranslation(['projects'])
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Projects'],
    client: accountsClient
  })
  const modal = useAlert()

  const handleRequest = id => {
    if (!modal.confirm({ title: t('project.remove.confirmation') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('project.remove.success') })
      } else {
        notify.error({ title: t('project.remove.error') })
      }
    })
  }

  return [handleRequest, state]
}
